module.exports = __webpack_public_path__ + "static/media/strutture-beach-volley-sabbia-gioco-noleggiocampi.d21f66d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/campi/beachvolley/slider3/strutture-beach-volley-sabbia-gioco-noleggiocampi.jpg
// module id = 666
// module chunks = 0